/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M16.75 15.55c2.2624-1.5273 3.75-4.1149 3.75-7.05C20.5 3.8056 16.6944 0 12 0S3.5 3.8056 3.5 8.5c0 2.9351 1.4876 5.5227 3.75 7.05V19c0 1.2695.8602 2.3381 2.0296 2.6547C9.4753 22.9816 10.6187 24 12 24c1.3813 0 2.5247-1.0184 2.7204-2.3453C15.8898 21.3381 16.75 20.2695 16.75 19v-3.45ZM12 22.5c-.5126 0-.9531-.3085-1.146-.75h2.292c-.1929.4415-.6334.75-1.146.75Zm3.25-6.1435C14.2488 16.7712 13.1511 17 12 17s-2.2488-.2288-3.25-.6435V19c0 .6904.5596 1.25 1.25 1.25h4c.6904 0 1.25-.5596 1.25-1.25v-2.6435ZM7.5061 9.2928a.75.75 0 0 1 .957.4572c.4246 1.201 1.4447 2.1216 2.7029 2.407a.75.75 0 0 1-.332 1.4629c-1.7655-.4007-3.1908-1.6886-3.785-3.37a.75.75 0 0 1 .4571-.957Z"
    clipRule="evenodd"
  />,
  'MenuInnovationFilled'
);
